import { Download } from 'lucide-react';
import { Modal, Button } from '../ui';

interface ExportSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  downloadUrl: string;
  count: number;
}

function ExportSuccessModal({ isOpen, onClose, downloadUrl }: ExportSuccessModalProps) {
  const handleDownload = () => {
    // Create a temporary link to download the file
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', 'contacts-export.txt');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Exportação Concluída" size="md">
      <div className="text-center py-4">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
          <Download className="h-6 w-6 text-green-600" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">
          Exportação concluída com sucesso!
        </h3>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          Os contatos foram exportados e estão prontos para download.
        </p>

        <div className="mt-4 bg-gray-50 dark:bg-gray-800 p-3 rounded-md text-left">
          <p className="text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Formato do arquivo:
          </p>
          <pre className="text-xs text-gray-600 dark:text-gray-400">
            contato,nome,canal,tipo
          </pre>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
            Este arquivo pode ser importado novamente na tela de contatos.
          </p>
        </div>

        <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
          <Button onClick={handleDownload} className="flex items-center justify-center">
            <Download className="h-4 w-4 mr-2" />
            Baixar Arquivo
          </Button>
          <Button variant="secondary" onClick={onClose}>
            Fechar
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ExportSuccessModal;
